<ds-modal #errorModal class="http-error-modal">
  <div class="error-title" dsModalTitle>{{title}}</div>
  <div class="error-message" dsModalContent>
    <div class="p-mb-2" [innerHTML]="errorMessage"></div>
    <div *ngIf="showAdmin">{{ 'skontaktujSieZAdministratorem' | transloco }}</div>
    <div class="p-mt-5 p-d-flex p-flex-row p-jc-end">
      <ds-button severity="primary" [label]="'zamknijOkno' | transloco" (onClick)="closeModal()"></ds-button>
    </div>
  </div>
</ds-modal>
